import { isMobile } from 'react-device-detect';
import cx from 'classnames';
import { ReactComponent as EliminatePaperBookSVG } from '../../../../assets/images/home/eliminate-paper-book.svg';
import { ReactComponent as EliminatePaperComplianceSVG } from '../../../../assets/images/home/eliminate-paper-compliance.svg';
import { ReactComponent as EliminatePaperFileSVG } from '../../../../assets/images/home/eliminate-paper-file.svg';
import { ReactComponent as EliminatePaperLeftSVG } from '../../../../assets/images/home/eliminate-paper-left.svg';
import { ReactComponent as EliminatePaperLeftMobileSVG } from '../../../../assets/images/home/eliminate-paper-left-mobile.svg';
import { ReactComponent as EliminatePaperRightMobileSVG } from '../../../../assets/images/home/eliminate-paper-right-mobile.svg';
import { ReactComponent as EliminatePaperRightSVG } from '../../../../assets/images/home/eliminate-paper-right.svg';
import { ReactComponent as EliminatePaperZapSVG } from '../../../../assets/images/home/eliminate-paper-zap.svg';
import './styles.scss';

const PreFooterBlock = ({ title, subtitle, setIsOpenScheduleDemoModal }) => {
  return (
    <div className={cx('eliminate-paper-block', { isMobile })}>
      <div className="eliminate-paper-left-block">
        {isMobile ? (
          <EliminatePaperLeftMobileSVG className="eliminate-paper-left-svg" />
        ) : (
          <EliminatePaperLeftSVG className="eliminate-paper-left-svg" />
        )}
        <div className="eliminate-paper-card eliminate-paper-customize-processes-card">
          <EliminatePaperZapSVG className="eliminate-paper-card-icon" />
          <p className="eliminate-paper-card-text">Customize Processes</p>
        </div>
        <div className="eliminate-paper-card eliminate-paper-staff-education-card">
          <EliminatePaperBookSVG className="eliminate-paper-card-icon" />
          <p className="eliminate-paper-card-text">Staff Education</p>
        </div>
      </div>
      <div className="eliminate-paper-center-block">
        <h3 className="eliminate-paper-title">{title}</h3>
        <p className="eliminate-paper-subtitle">{subtitle}</p>
        <button className="request-demo-btn" onClick={() => setIsOpenScheduleDemoModal(true)}>
          Request a Demo{' '}
          <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.25 9.3479H14.75" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9.5 4.0979L14.75 9.3479L9.5 14.5979" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
      <div className="eliminate-paper-right-block">
        {isMobile ? (
          <EliminatePaperRightMobileSVG className="eliminate-paper-right-svg" />
        ) : (
          <EliminatePaperRightSVG className="eliminate-paper-right-svg" />
        )}
        <div className="eliminate-paper-card eliminate-paper-compliance-card">
          <EliminatePaperComplianceSVG className="eliminate-paper-card-icon" />
          <p className="eliminate-paper-card-text">Compliance</p>
        </div>
        <div className="eliminate-paper-card eliminate-paper-file-card">
          <EliminatePaperFileSVG className="eliminate-paper-card-icon" />
          <p className="eliminate-paper-card-text">Survey Ready</p>
        </div>
      </div>
    </div>
  );
};

export default PreFooterBlock;
